"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setChecked = exports.fetchPublisherConsents = exports.default = exports.consentsSlice = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
const initialState = {
  publisherConsents: [],
  checked: [],
  loading: false,
  error: ''
};
const fetchPublisherConsents = exports.fetchPublisherConsents = (0, _toolkit.createAsyncThunk)('publisherConsents', async (publisherId, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const {
      consents
    } = await (0, _api.getConsents)(publisherId);
    return consents;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});
const consentsSlice = exports.consentsSlice = (0, _toolkit.createSlice)({
  name: 'publisherConsents',
  initialState,
  reducers: {
    setChecked(state, _ref2) {
      let {
        payload
      } = _ref2;
      state.checked[payload] = !state.checked[payload];
    }
  },
  extraReducers: {
    [fetchPublisherConsents.pending]: state => {
      state.loading = true;
    },
    [fetchPublisherConsents.fulfilled]: (state, _ref3) => {
      let {
        payload
      } = _ref3;
      state.publisherConsents = payload;
      state.checked = new Array(payload.length).fill(false);
      state.loading = false;
    },
    [fetchPublisherConsents.rejected]: (state, _ref4) => {
      let {
        payload
      } = _ref4;
      if (payload.includes('Invalid param publisherId')) {
        state.error = 'noPublisherId';
      } else state.error = payload;
      state.loading = false;
    }
  }
});
const {
  setChecked
} = consentsSlice.actions;
exports.setChecked = setChecked;
var _default = exports.default = consentsSlice.reducer;